import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  fontFillColor?: string;
  iconFillColor?: string;
};

export function IconEciuUniversity({
  fontFillColor,
  iconFillColor,
  ...restProps
}: Props) {
  const fontFill = fontFillColor ?? "#FAA627";
  const iconFill = iconFillColor ?? "#002A41";

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 292.1 175.3"
      {...restProps}
    >
      <g>
        <path
          fill={fontFill}
          d="M111.1,55.7c1,0.6,1.9,1.1,2.7,1.8L205.8,5v68.5L36.2,170.3v-68.5l63-36c-1.2-0.5-2.5-0.9-3.9-1.1l-62,35.4
		v75.2L208.7,75.2V0L111.1,55.7z"
        />
        <path
          fill={iconFill}
          d="M124.6,94.5c-1.8,15.5-14.6,25.7-34.2,25.7c-19.9,0-33.2-11.8-35.7-29l16-9.1c-0.1,1.1-0.2,2.2-0.2,3.3
		c0,12.9,7.3,21.1,19.9,21.1c9.6,0,15.9-4.7,17.6-12.1H124.6z M113.9,57.5c-0.9-0.6-1.8-1.2-2.7-1.8c-5.5-3.2-12.5-5-20.7-5
		c-22.1,0-36.1,14.6-36.1,34.7c0,0.9,0,1.8,0.1,2.6l17-9.7c2.2-8.8,8.9-14.1,19.1-14.1c1.7,0,3.3,0.2,4.8,0.4
		c1.4,0.3,2.7,0.6,3.9,1.1c4.7,2,7.9,5.7,9,10.5h16.5C123.7,68.5,119.9,62,113.9,57.5z M147.7,158.7c2.3,0,4-1.3,4.8-2.5v2.1h4.6
		v-17.8h-4.7v10.7c0,1.9-1.2,3.3-3.2,3.3c-1.6,0-3-1.2-3-3.2v-10.8h-4.7v10.3C141.5,154.5,142.6,158.7,147.7,158.7z M170.3,140
		c-2.3,0-4,1.3-4.8,2.5v-2.1h-4.6v17.8h4.7v-10.7c0-1.9,1.2-3.3,3.2-3.3c1.6,0,3,1.2,3,3.2v10.8h4.7V148
		C176.5,144.2,175.4,140,170.3,140z M179.9,136.2c0,1.5,1.2,2.7,2.7,2.7c1.6,0,2.8-1.2,2.8-2.7c0-1.5-1.2-2.7-2.8-2.7
		C181.1,133.5,179.9,134.7,179.9,136.2z M180.3,158.3h4.7v-17.8h-4.7V158.3z M199.2,158.3l6.4-17.8h-5l-4.1,12.8l-4.1-12.8h-5
		l6.4,17.8H199.2z M206.9,149.4c0,5.3,3.6,9.3,9.4,9.3c4.4,0,6.8-2.7,7.5-3.9l-3.1-2.4c-0.5,0.7-1.9,2.2-4.3,2.2
		c-2.6,0-4.5-1.7-4.6-4.1h12.5c0-0.3,0-0.7,0-1c0-5.8-3.1-9.5-8.7-9.5C210.6,140,206.9,144.1,206.9,149.4z M211.9,147.5
		c0.2-2,1.6-3.6,3.8-3.6c2.1,0,3.7,1.4,3.8,3.6H211.9z M236.8,140c-2.3,0-4.1,1.3-4.9,3v-2.6h-4.6v17.8h4.7v-7.8
		c0-3.5,1.3-5.7,4.8-5.7V140z M245.3,158.7c3.8,0,6.8-2.2,6.8-5.7c0-6.4-8.4-5-8.4-7.8c0-0.9,0.7-1.4,1.8-1.4c1.7,0,2.7,1,3.2,1.7
		l3.1-2.3c-0.9-1.4-2.7-3.2-6.1-3.2c-3.6,0-6.5,2-6.5,5.3c0,6.3,8.4,5.3,8.4,8c0,1-0.9,1.6-2.2,1.6c-2,0-3.2-0.9-4.1-1.9l-2.8,2.5
		C239.6,157,241.8,158.7,245.3,158.7z M254.6,136.2c0,1.5,1.2,2.7,2.7,2.7c1.6,0,2.8-1.2,2.8-2.7c0-1.5-1.2-2.7-2.8-2.7
		C255.8,133.5,254.6,134.7,254.6,136.2z M255,158.3h4.7v-17.8H255V158.3z M264.2,140.5h-1.9v3.8h1.9v7c0,4.8,1.9,7.2,6.1,7.2
		c1.3,0,2-0.2,2-0.2v-4c-0.4,0-0.5,0-0.9,0c-1.8,0-2.6-0.5-2.6-3.2v-6.9h3.3v-3.8h-3.3v-3.7h-4.6V140.5z M283,164.4l9.1-23.9h-4.9
		l-4,11.6l-4-11.6h-5l6.8,17.4l-2.5,6.5H283z M44.7,64.8V52.6H0v65.7h33.3v-12.2H15.5V91.6h16.7V79.7H15.5V64.8H44.7z M36.2,106.1
		v12.2h8.5v-12.2H36.2z M141.5,52.6v57.6l15.5-8.9V52.6H141.5z M141.5,113.5v4.8h15.5v-13.6L141.5,113.5z M179.6,52.6v35.9l15.5-8.9
		v-27H179.6z M226.4,52.6v38c0,6.6-3,13.9-15.6,13.9s-15.6-7.3-15.6-13.9v-7.7l-15.5,8.9v0.1c0,5,1.4,10.2,3.8,14h0
		c4.9,7.6,14.4,12.4,27.3,12.5h0.1c13,0,22.4-4.8,27.3-12.5h0c2.4-3.8,3.7-9,3.8-14V52.6H226.4z"
        />
      </g>
    </svg>
  );
}
